import { Fancybox } from '@fancyapps/ui';
window.addEventListener('load', function () {
  Fancybox.bind('[data-fancybox]', {});
});
